import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FAQService {

  constructor(private crudService: CrudService) { }

  Save(model: any): Observable<any> { 
    return this.crudService.post<any>('api/FAQ/Save', model);
  }
}
